export const Partner = {
	list: function() {
		//console.log("partners")
		jQuery('.btn.toggle-visibility').on('click', function() {
			jQuery(this).toggleClass('visible');
			jQuery(this).toggleClass('btn-success');
			jQuery(this).toggleClass('btn-danger');

			if (jQuery(this).hasClass('visible')) {
				jQuery(this).html(I18n.t('option_yes'));

			} else {
				jQuery(this).html(I18n.t('option_no'));
			}
		});
	}
};